<template lang="pug">
//- Dentro de un menú desplegado: item con su texto visible.
li.row-menu-li(v-if="enMenu" role="none")
  button.row-menu-item(
    type="button"
    role="menuitem"
    :disabled="disabled"
    :class="{ 'is-danger': danger }"
    @click="run"
  )
    i.row-menu-icon(:class="icon")
    span {{ tooltip }}

//- Acción única o suelta: botón con ícono y tooltip.
Button.row-action(
  v-else
  :class="{ 'row-action-danger': danger }"
  :icon="icon"
  :disabled="disabled"
  :aria-label="tooltip"
  v-tooltip.top="tooltip"
  text
  severity="secondary"
  @click="$emit('click', $event)"
)
</template>

<script>
/**
 * Acción individual de una fila de tabla.
 *
 * Se dibuja según el contexto: dentro de un menú desplegado es un item con
 * su texto visible; si la fila tiene una sola acción, o si está suelta
 * —como el "borrar producto" de la carga de una compra—, es un botón con
 * ícono, porque desplegar un menú para elegir entre una opción es un clic
 * de más.
 *
 * Criterio de color: las acciones de fila son neutras. El color se reserva
 * para significado, no para diferenciar botones entre sí; por eso solo la
 * destructiva se pinta. Antes convivían cinco severities en la misma celda
 * —incluida una acción como texto azul ("CC") en medio de íconos—, así que
 * ninguna destacaba y la fila se leía como un semáforo.
 */
export default {
  name: 'RowAction',
  inject: {
    rowMenu: { default: null },
  },
  props: {
    /** Clase del ícono de PrimeIcons, ej: 'pi pi-pencil' */
    icon: {
      type: String,
      required: true,
    },
    /** Qué hace la acción. Es el texto del item, y el tooltip si va suelta. */
    tooltip: {
      type: String,
      required: true,
    },
    /** Acciones destructivas (eliminar, anular). Las pinta de rojo. */
    danger: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    enMenu() {
      return Boolean(this.rowMenu?.plegado);
    },
  },
  methods: {
    run(event) {
      // Cierra antes de ejecutar: la acción puede navegar o abrir un modal,
      // y el panel no tiene que quedar flotando encima.
      this.rowMenu.close();
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
.row-menu-li {
  display: block;
}

.row-action {
  width: 2rem;
  height: 2rem;
  padding: 0;
  color: var(--escality-gray-500);
}

.row-action:not(:disabled):hover {
  color: var(--escality-primary);
  background: var(--escality-primary-50);
}

.row-action-danger:not(:disabled):hover {
  color: var(--escality-danger-dark);
  background: var(--escality-danger-50);
}
</style>
